<div id="sidebar-right" [ngClass]="{ 'sidebar-right-open': navService.sidebarRightOpen == true }">
  <div class="sidebar-right-buttons">
    <button mat-icon-button (click)="openSidebarRight()" [ngClass]="{'test-bot-button': true, 'active': navService.sidebarRightOpen === true}">
      <mat-icon>play_circle_filled</mat-icon>
    </button>
  </div>
  <div class="sidebar-right-content">
    <div id="sidebar-auto-padding">
      <ebo-webchat *ngIf="navService.sidebarRightOpened === true"></ebo-webchat>
    </div>
  </div>
</div>
